<template>
  <div class="shadow-light rounded-xl p-2 pr-3" :class="{'background-white': !nightMode, 'background-black': nightMode}">
    <router-link
      :to="{ name: 'users.show', params: { username: user ? user.username : 'username' } }"
    >
      <div class="d-flex justify-content-between align-items-center ">
        <div class="mr-2">
          <div class="author-image-circle background-cover" :style="profileImage"></div>
        </div>
        <span class="text-color1 font-size-small" v-if="user"><span class="text-color2">@</span>{{ user.username }}</span>
        <BaseIcon
          v-if="user && user.is_verified"
          size="xxSmall"
          class="ml-1"
        >
          <VerifiedIcon
            class="profile"
          />
        </BaseIcon>
      </div>
    </router-link>
  </div>
</template>

<script>

import variables from '@/mixins/variables'
import BaseIcon from '@/components/common/Icon/BaseIcon.vue'
import VerifiedIcon from '@/components/common/Icon/VerifiedIcon.vue'
import { mapState } from 'vuex'

export default {
  name: 'UserBasicTag',
  props: ['user'],
  mixins: [variables],
  components: {
    BaseIcon,
    VerifiedIcon
  },
  computed: {
    ...mapState({
      nightMode: state => state.nightMode
    }),
    profileImage () {
      return {
        backgroundImage: this.user ? `url('${this.user.avatar}')` : `url('${this.noAvatarUrl}')`
      }
    }
  }

}
</script>
